import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

class CustomPrevArrow extends React.Component {
    constructor(props) {
        super(props);
    }

    render () {
        return(
            <CustomPrevArrowContainer id="arrow" onClick={this.props.onClick}>
                <i className="fas fa-chevron-left custom-chevron-arrow"></i>
            </CustomPrevArrowContainer>
        );
    }
}

export default CustomPrevArrow;

const CustomPrevArrowContainer = styled.div`
    display: none;
    background-color: rgba(255,255,255);
    opacity: 0;
    text-align: center;
    vertical-align: middle;
    border: 1px solid #ccc;
    height: 5rem;
    width: 3rem
    padding-top: 1.5rem;
    position: absolute;
    top: 2.75%;
    left: 0%;
    z-index: 1;
    cursor: pointer;

    @media (min-width: 767px) {
        display: inline-block;
    }
    @media (min-width: 940px) {
        top: 9%;
    }
    @media (min-width: 1080px) {
        top: 20%;
    }
`;

CustomPrevArrow.propTypes = {
    onClick: PropTypes.func
};